export default __webpack_public_path__ + "static/media/flag-saudi-inactive.74d032ac.svg";